import React from "react";
import { cn } from "@/lib/utils";

interface ContainerWithHeaderProps {
    children?: React.ReactNode;
    heading?: String;
    subText?: String;
    tools?: React.ReactNode;
}

const ContainerWithHeader = (props: ContainerWithHeaderProps) => {
    return (
        <div className="w-full min-w-0">
            <div className="mb-4 flex flex-col gap-3 sm:mb-6 sm:flex-row sm:items-start sm:justify-between">
                <div className="min-w-0">
                    <h3 className="text-xl font-normal leading-snug text-secondary sm:text-2xl md:text-3xl">
                        {props.heading}
                    </h3>
                    {props.subText && (
                        <p className="mt-1 text-sm text-muted-foreground sm:text-base">
                            {props.subText}
                        </p>
                    )}
                </div>
                {props.tools && (
                    <div className="flex w-full flex-shrink-0 flex-wrap items-center gap-2 sm:w-auto sm:justify-end">
                        {props.tools}
                    </div>
                )}
            </div>
            {props.children}
        </div>
    );
};

export default ContainerWithHeader;
